import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast-service';
import { TokenService } from '../services/token.service';
import { SessionService } from '../services/session.service';
import { PresenceService } from '../services/presence.service';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';

const AUTH_ENDPOINTS = ['/Login', '/VerifyMfa', '/Refresh', '/Logout'];

export const ApiErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const toast = inject(ToastService);
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const sessionService = inject(SessionService);
  const presenceService = inject(PresenceService);

  const isAuthEndpoint = (url: string) => AUTH_ENDPOINTS.some(endpoint => url.includes(endpoint));

  const redirectToLogin = () => {
    presenceService.stop();
    tokenService.clear();
    toast.showErrorToast('Session Expired');
    setTimeout(() => {
      router.navigateByUrl('/login');
    }, 2000);
  };

  const handleError = (error: HttpErrorResponse) => {
    console.error('[ApiErrorInterceptor] Error:', {
      status: error.status,
      url: error.url,
      message: error.message,
      error: error.error
    });

    if (error.status === 401) {
      // Access token expired mid-request but the endpoint isn't login/refresh/logout itself:
      // silently refresh and retry once before giving up on the session.
      if (!isAuthEndpoint(request.url)) {
        return sessionService.refresh().pipe(
          switchMap(() => next(request)),
          catchError(() => {
            redirectToLogin();
            return throwError(() => error);
          })
        );
      }

      redirectToLogin();
    } else if (error.status === 400) {
       toast.showErrorToast(error?.error);
    }
    return throwError(() => error);
  };

  return next(request).pipe(
    filter(event => event instanceof HttpResponse),
    tap(event => {
      const response = event as HttpResponse<any>;
      const responseBody = response.body;
      //console.log('[ApiErrorInterceptor] Response OK:', { url: response.url, status: response.status });
      //console.log('[ApiErrorInterceptor] Response Headers:', response.headers.keys().reduce((acc: any, key) => ({ ...acc, [key]: response.headers.get(key) }), {}));
      // Optional: handle custom error messages in response
      // const { success, errorMessage } = responseBody;
      // if (success === false && errorMessage) {
      //   notification.error('Error', errorMessage);
      // }
    }),
    catchError(handleError)
  );
};
